import { useGetList } from 'react-admin';
import { MerchantPlatform } from 'types/embedded/merchant';

export const useGetPlatforms = () => {
  const { data } = useGetList<MerchantPlatform>('merchant_platforms');
  const platforms = data?.map(({ id, name, value }) => ({ id, label: name, value })) || [];

  return platforms;
};
